import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import VerticalDndSSS from "../../components/dnd/VerticalDndSSS"
import Button from "../../components/shared/Button"
import { showModal } from "../../features/modal/modalSlice"

const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
      width: calc(100% - 60px);
      gap: 60px;
      margin: 30px;


      .top-container{
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin: 20px 0;
      }


      .list{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
    }
}
`


const SikcaSorulanSorularAdmin = () => {

  const {SSSList} = useSelector(state => state.adminSett)

  const dispatch = useDispatch()

  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Sıkça Sorulan Sorular (SSS)"} position='sticky'/>
      <div className="content">
        <div className="top-container">
            <Button color={"#F4F4F4"} background={"#0EAC00"} width="180px" radius={"10px"} text={"SSS Ekle"} padding="0 10px" handleClick={() => dispatch(showModal("addSSSItem"))}/>
        </div>
        {
          (SSSList && SSSList.length > 0) && 
          <div className="list">
            <VerticalDndSSS data={SSSList}/>
          </div>
        }
      </div>
    </div>
  </Container>
  )
}

export default SikcaSorulanSorularAdmin